import { Entry } from 'contentful'
import {
  IMarketoForm as IContentfulMarketoForm,
  IMarketoFormFields as IContentfulMarketoFormFields,
} from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import {
  IProps as MarketoFormV2Props,
  MarketoFormV2,
} from 'marketing-site/src/library/components/MarketoFormV2'
import { getHexColorFromName, getTypedIcon } from 'marketing-site/src/library/utils'
import React from 'react'
import { transformCTAWithBackground } from '../elements/ContentfulCTALink'

export function isMarketoForm(entry: Entry<any>): entry is IContentfulMarketoForm {
  return entry.sys.contentType?.sys.id === 'marketoForm'
}

export const ContentfulMarketoForm = (data: IContentfulMarketoForm): React.ReactElement => (
  <EntryMarker entry={data}>
    <MarketoFormV2 {...transformMarketoFormV2(data.fields)} />
  </EntryMarker>
)

// redirectUrl may be injected from the ContentfulModalButton component
export function transformMarketoFormV2(fields: IContentfulMarketoFormFields): MarketoFormV2Props {
  const { marketoForm, submitButtonLabel, backgroundColor, forceBusinessEmail } = fields

  return {
    ...fields,
    formId: marketoForm.id,
    submitButtonLabel: submitButtonLabel || marketoForm.buttonLabel,
    backgroundColor: backgroundColor && getHexColorFromName(backgroundColor),
    forceBusinessEmail: forceBusinessEmail || false,
    icon: fields.icon && getTypedIcon(fields.icon),
    secondaryCTA: fields.secondaryCTA && transformCTAWithBackground(fields.secondaryCTA),
  }
}
